import { render, staticRenderFns } from "./zlNewPay.vue?vue&type=template&id=2a065167&scoped=true&"
var script = {}
import style0 from "./zlNewPay.vue?vue&type=style&index=0&id=2a065167&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a065167",
  null
  
)

export default component.exports